// 提问时的选择（查哪些资料、用哪个智能体、哪个模型），记在本机，下次打开沿用。

export type Scope =
  | { kind: 'all' }
  | { kind: 'kb'; kbId: string }
  | { kind: 'doc'; kbId: string; knowledgeId: string; title: string }
  | { kind: 'none' }

export interface ChatPrefs {
  scope: Scope
  agentId?: string
  modelId?: string
}

const KEY = 'lingzhi-web.chat-prefs'
export const DEFAULT_PREFS: ChatPrefs = { scope: { kind: 'all' } }

export function loadPrefs(): ChatPrefs {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) ?? 'null') as ChatPrefs | null
    if (!raw || typeof raw !== 'object') return DEFAULT_PREFS
    // 只问一篇是临时的，不沿用到下一次
    const scope = raw.scope && raw.scope.kind !== 'doc' ? raw.scope : DEFAULT_PREFS.scope
    return { scope, agentId: typeof raw.agentId === 'string' ? raw.agentId : undefined, modelId: typeof raw.modelId === 'string' ? raw.modelId : undefined }
  } catch {
    return DEFAULT_PREFS
  }
}

export function savePrefs(p: ChatPrefs) {
  try {
    localStorage.setItem(KEY, JSON.stringify(p))
  } catch {
    // 记不住也没关系
  }
}

/**
 * 范围 → 请求里的 knowledge_base_ids / knowledge_ids。
 * 灵智原生把两者取并集（knowledge_ids 是「再加上这几篇」），所以只问一篇时不能再带它所在的库，否则会搜整个库。
 */
export function scopeToRequest(scope: Scope, allKbIds: string[]): { knowledgeBaseIds: string[]; knowledgeIds: string[] } {
  switch (scope.kind) {
    case 'all':
      return { knowledgeBaseIds: allKbIds, knowledgeIds: [] }
    case 'kb':
      return { knowledgeBaseIds: [scope.kbId], knowledgeIds: [] }
    case 'doc':
      return { knowledgeBaseIds: [], knowledgeIds: [scope.knowledgeId] }
    case 'none':
      return { knowledgeBaseIds: [], knowledgeIds: [] }
  }
}
